import { useEffect } from 'react';
import { Outlet, Navigate } from 'react-router-dom';


import { useAuthStore } from "../../store/auth.store.ts";
import { SidebarProvider } from "../../context/Sidebar"; 

export default function PrivateRoute({ children }) {
  const { isAuthenticated, usuario, token } = useAuthStore((state) => state);
  const setToken = useAuthStore((state) => state.setToken);
  const setUsuario = useAuthStore((state) => state.setUsuario);

  const checkIfAuthenticated = () => {
    if (!token) {
      setToken("");
      setUsuario(null);
      return false;
    }

    // Verificar si el token se encuentra expirado
    const jwtPayload = JSON.parse(window.atob(token.split('.')[1]))
    const isExpired = Date.now() >= jwtPayload.exp * 1000;
    if (isExpired) {
      setToken("");
      setUsuario(null);
      return false;
    }
    return true;
  }

  useEffect(() => {
    checkIfAuthenticated();
  }, [])

  
  

  // Si no está autenticado, redirigir directamente a INGRESO
  if (!isAuthenticated || !usuario) {
    return <Navigate to="/login" replace />;
  }

  // Verificar si el usuario tiene el rol ADMIN o MASTER
  const isAdmin = usuario.roles[0].codigo.includes('ADMIN') || usuario.roles[0].codigo.includes('MASTER');
  
  if (!isAdmin) {
    return <Navigate to="/home" replace />;
  }


  console.log("Usuario autenticado:", usuario);

  // Si está autenticado, mostrar el layout privado con sus rutas



  console.log("PrivateRoute children:", children);

  return children;
}